import { Box, Card, Grid, Stack, Typography, styled, useMediaQuery } from "@mui/material";
import React from "react";
import { Spidometer } from "./Spidometer";
import { CreditRatingInfo } from "./CreditRatingInfo";
import { Button } from "components/Button";
import { CreditRatingHistory } from "./CreditRatingHistory";
import { desktop } from "utils";
import { CreditworthinessRating } from "./CreditworthinessRating";

export const Report = ({ data }) => {
  const matchesDesktop = useMediaQuery(desktop);

  const { score, ppd, history, companyName } = data || {};

  return (
    <Stack height="100%" justifyContent="space-between" alignItems="center" px="0.5rem" pt="1.5rem" overflow="auto">
      <Grid container alignItems="center" rowSpacing={2}>
        <Grid
          container
          alignItems="center"
          sx={
            matchesDesktop && {
              borderRadius: "20px",
              padding: "1rem",
              background: "#fff",
              boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
            }
          }
        >
          <Grid item xs={12}>
            <Typography variant="h2" color="primary" textAlign="center" my="2rem">
              {companyName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            sx={{
              px: "0.5rem",
            }}
          >
            <Spidometer score={Math.round(score)} riskProbability={ppd} />
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography fontSize="20px" fontWeight={400} color="speedometer.blue.main">
              Įtaka kredito reitingui
            </Typography>
            <Typography variant="body3" color="#999999">
              Kriterijai ir jų informacija, darantys įtaką kredito reitingui
            </Typography>
            <Box mt="1.5rem">
              <CreditRatingInfo />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <StyledCard>
            <CreditworthinessRating score={score} ppd={ppd} companyName={companyName} />
          </StyledCard>
        </Grid>

        <Grid item xs={12}>
          <StyledCard>
            <Typography fontSize="20px" fontWeight={400} color="speedometer.blue.main">
              Kredito reitingo istorija
            </Typography>
            <Typography variant="body3" color="#999999">
              Įmonės kredito reitingo pokytis per paskutinius 12mėn.
            </Typography>
            <CreditRatingHistory history={history} />
          </StyledCard>
        </Grid>
      </Grid>
      <Grid item xs={12} pt="1rem" pb="2.5rem">
        <a href="https://finpass.eu/home?ref=swedbank" target="_blank" rel="noreferrer">
          <Button mt="auto">ĮSIGYTI PILNĄ ATASKAITĄ</Button>
        </a>
      </Grid>
    </Stack>
  );
};

const StyledCard = styled(Card)({
  borderRadius: "20px",
  padding: "2rem 1rem",
  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.25)",
  background: "#fff",
});
